import { useEffect, useState } from "react";

import { ACTIVITY_CONTEXT } from "Constants/constants";
import useDecodedParams from "Hooks/useDecodedParams";
import { loadProjectActivities, getSelectors } from "Reducers/activity";
import { allFilterNames } from "src/organization/common/containers/ActivitySection/util";
import { useAppSelector, useAppDispatch } from "Store/hooks";

export const useProjectActivityManager = () => {
  const dispatch = useAppDispatch();
  const { organizationId, projectId, environmentId } = useDecodedParams<{
    organizationId: string;
    projectId: string;
    environmentId: string;
  }>();

  const [canDispatchProjectActivities, setCanDispatchProjectActivities] =
    useState(true);

  const { completed, isLoading } = getSelectors(ACTIVITY_CONTEXT.Project, {
    organizationId,
    projectId,
    environmentId
  });

  const completedActivity = useAppSelector(completed);
  const projectActivitiesAreLoading = useAppSelector(isLoading);

  useEffect(() => {
    if (
      !projectActivitiesAreLoading &&
      !completedActivity.length &&
      canDispatchProjectActivities
    ) {
      setCanDispatchProjectActivities(false);
      dispatch(
        loadProjectActivities({
          projectDescriptionId: projectId,
          organizationDescriptionId: organizationId,
          filterNames: allFilterNames,
          context: ACTIVITY_CONTEXT.Project
        })
      );
    }
  }, [
    dispatch,
    organizationId,
    projectId,
    environmentId,
    projectActivitiesAreLoading,
    completedActivity.length,
    canDispatchProjectActivities
  ]);
};
